var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiAssistantColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.5,
    height: 38.5,
    viewBox: "0 0 38.5 38.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AI-assistant-colour",
    transform: "translate(-26 -527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    transform: "translate(26 527)",
    fill: "#ffa100",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.25,
    cy: 19.25,
    r: 19.25,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.25,
    cy: 19.25,
    r: 18.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(36.621 532.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2463268802528",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M8.7,8.626a24.08,24.08,0,0,1,4.617.447A1.83,1.83,0,0,1,14.8,10.956a11.1,11.1,0,0,1-.243,1.705,21.859,21.859,0,0,1-1.125,3.5,1.807,1.807,0,0,1-1.422,1.114,24.138,24.138,0,0,1-3.3.228,24.123,24.123,0,0,1-3.3-.228,1.807,1.807,0,0,1-1.422-1.114,21.844,21.844,0,0,1-1.127-3.5,11.219,11.219,0,0,1-.241-1.7A1.83,1.83,0,0,1,4.087,9.073,24.08,24.08,0,0,1,8.7,8.626ZM8.168,3.25V5.27a28.185,28.185,0,0,0-4.876.52A4.059,4.059,0,0,0,.01,10a13.865,13.865,0,0,0,.306,2.172,26,26,0,0,0,1.325,4.142A4.042,4.042,0,0,0,4.831,18.8a28.256,28.256,0,0,0,7.746,0,4.042,4.042,0,0,0,3.19-2.493,26,26,0,0,0,1.325-4.142A14.036,14.036,0,0,0,17.4,10,4.059,4.059,0,0,0,14.117,5.79a28.2,28.2,0,0,0-4.876-.52V3.25a.538.538,0,0,0-.266-.463V1.344a.7.7,0,1,0-.543,0V2.788a.538.538,0,0,0-.266.463Z",
    transform: "translate(-0.004 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M34.561,80.061a.74.74,0,1,0-.741-.741A.74.74,0,0,0,34.561,80.061Z",
    transform: "translate(-28.991 -67.358)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M78.41,80.061a.74.74,0,1,0-.74-.741A.74.74,0,0,0,78.41,80.061Z",
    transform: "translate(-66.578 -67.358)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M26.677,128.19c-3.152,0-5.707.554-5.707,2.842a6.111,6.111,0,0,0,5.707,5.443,6.111,6.111,0,0,0,5.707-5.443C32.383,128.744,29.829,128.19,26.677,128.19Z",
    transform: "translate(-17.976 -109.883)",
    fill: "#333"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantColour);
export default __webpack_public_path__ + "static/media/AI-assistant-colour.be694fc0a7df3d7d7db1205f9dfe9aff.svg";
export { ForwardRef as ReactComponent };